import { FC, useEffect, useState } from 'react';
import { Box, Grid, FormControl, Select, MenuItem, InputLabel, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../../../atomic/atoms';
import { SCUIGeneralDrawerHeader } from '../../../../atomic/molecules';
import { GeneralQuery } from '../../../../services/query';
import { initialState, ISelectItem } from '../../Installment.helper';
import { enumSnackbarStatusType } from '../../../../types/enums';
import { PaymentCommand } from '../../../../services/command';
import { IOM } from '../../installmentOptionManagement.classes';

export const SCUIInstallmentInsert: FC<IProps> = ({ setShowSnackbar, setSnackbarProperties, search, onClose }) => {
    const { t } = useTranslation();

    const [data, setData] = useState<any>(initialState.installmentFilters);

    const [countries, setCountries] = useState<ISelectItem[]>([]);
    const [installmentOptions, setInstallmentOptions] = useState<ISelectItem[]>([]);

    const getCountryList = async () => {
        let languageCode = localStorage.getItem('lan');
        const countryList = await GeneralQuery.GetRegionalCountryList(languageCode);

        let result: ISelectItem[] = [];
        if (countryList && countryList.data.length > 0) {
            result = countryList.data.map((item: any) => ({
                id: item.countryId,
                name: item.countryName,
            }));
        }

        setCountries(result);
    };

    const getInstallmentOptions = async () => {
        let options: ISelectItem[] = [
            { id: 1, name: '0' },
            { id: 2, name: '2' },
            { id: 3, name: '3' },
            { id: 4, name: '4' },
            { id: 5, name: '5' },
            { id: 6, name: '6' },
            { id: 7, name: '7' },
            { id: 8, name: '8' },
            { id: 9, name: '9' },
            { id: 10, name: '10' },
            { id: 11, name: '11' },
            { id: 12, name: '12' },
        ];
        setInstallmentOptions(options);
    };

    useEffect(() => {
        getCountryList();
        getInstallmentOptions();
    }, []);

    const formValidation = () => {
        let validationOk: boolean = false;
        let message = '';

        if (data.country == null) {
            message = t('general.pleaseSelectCountry');
        } else if (data.creditCardType == null) {
            message = t('installmentOptionManagement.pleaseSelectBank');
        } else if (data.numberOfInstallment?.length == 0) {
            message = t('installmentOptionManagement.pleaseSelectInstallmentInformation');
        } else {
            validationOk = true;
        }

        if (!validationOk) {
            setShowSnackbar(true);
            setSnackbarProperties({
                show: true,
                autoHideDuration: 2000,
                message: message,
                status: enumSnackbarStatusType.warning,
            });
        }

        return validationOk;
    };

    const onClick = async () => {
        let validationOk: boolean = formValidation();
        if (validationOk) {
            let numberOfInstallments = data.numberOfInstallment?.map((x: any) => parseInt(x.name));

            let response = await PaymentCommand.AddOrUpdateInstallmentManagement({
                countryId: data.country?.id ?? null,
                creditCardTypeId: data.creditCardType?.id ?? 0,
                creditCardTypeName: data.creditCardType?.name ?? '',
                numberOfInstallments: numberOfInstallments ?? null,
                // status: filterInput.status?.id ?? 0,
            });

            let applySearch = false;
            let message = '';
            let messageStatus: enumSnackbarStatusType = enumSnackbarStatusType.info;
            if (response) {
                message = t('installmentOptionManagement.bankInformationAdded');
                messageStatus = enumSnackbarStatusType.success;
                applySearch = true;
            } else {
                message = t('general.anErrorOccured');
                messageStatus = enumSnackbarStatusType.danger;
            }

            setSnackbarProperties({
                show: true,
                autoHideDuration: 2000,
                message: message,
                status: messageStatus,
            });
            setShowSnackbar(true);

            if (applySearch) {
                search();
            }
            onClose();
        }
    };

    return (
        <form
            className={IOM.insertForm}
            onSubmit={async (e: any) => {
                e.preventDefault();
            }}
        >
            <Grid container spacing={1} style={{ justifyContent: 'center' }}>
                <Box className={IOM.insertHeader}>
                    <SCUIGeneralDrawerHeader header={t('general.addNew')} onClose={onClose} />
                </Box>

                <Grid className={IOM.insertFieldCountry}>
                    <FormControl style={{ margin: '8px', width: 410 }}>
                        <InputLabel id="labelCountry">{t('general.country')}</InputLabel>
                        <Select
                            className={IOM.inputInsertCountry}
                            labelId="labelCountry"
                            id="parentMenuLabel"
                            // value={data.country?.id}
                            label={t('general.country')}
                            onChange={(event) => {
                                const { value } = event.target;
                                setData({
                                    ...data,
                                    country: {
                                        id: value,
                                        name: countries.find((x) => x.id == value)?.name,
                                    },
                                });
                            }}
                        >
                            {countries.length > 0 &&
                                countries.map((item: any) => {
                                    return (
                                        <MenuItem
                                            value={item.id}
                                            key={item.id}
                                            className={IOM.insertCountryOption}
                                            data-country-id={item.id}
                                            data-country-name={item.name}
                                        >
                                            {item.name}
                                        </MenuItem>
                                    );
                                })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid className={IOM.insertFieldBank}>
                    <FormControl style={{ margin: '8px', width: 410 }}>
                        <TextField
                            className={IOM.inputInsertBank}
                            id="inputBank"
                            label={t('general.bank')}
                            variant="outlined"
                            onChange={(event: any) => {
                                const { value } = event.target;
                                if (value != '' && value != undefined) {
                                    setData({
                                        ...data,
                                        creditCardType: {
                                            id: 0,
                                            name: value,
                                        },
                                    });
                                }
                            }}
                        />
                    </FormControl>
                </Grid>
                <Grid className={IOM.insertFieldNumberOfInstallments}>
                    <FormControl style={{ margin: '8px', width: 410 }}>
                        <TextField
                            className={IOM.inputInsertNumberOfInstallments}
                            select
                            id="selectNumberOfInstallments"
                            variant="outlined"
                            label={t('general.numberOfInstallments')}
                            slotProps={{
                                select: {
                                    label: '',
                                    multiple: true,
                                    value: data.numberOfInstallment?.map((x: any) => x.id) ?? [],
                                    onChange: (event: any) => {
                                        const { value } = event.target;
                                        let options: any = [];
                                        if (value) {
                                            value.map((item: any) => {
                                                options.push({
                                                    id: item,
                                                    name: installmentOptions.find((x) => x.id == item)?.name,
                                                });
                                            });

                                            setData({
                                                ...data,
                                                numberOfInstallment: options,
                                            });
                                        }
                                    },
                                },
                            }}
                        >
                            {installmentOptions.length > 0 &&
                                installmentOptions.map((item: any) => {
                                    return (
                                        <MenuItem
                                            key={item.id}
                                            value={item.id}
                                            className={IOM.insertInstallmentOption}
                                            data-installment-id={item.id}
                                            data-installment-name={item.name}
                                        >
                                            {item.name == '0'
                                                ? t('installmentOptionManagement.singlePayment')
                                                : item.name}
                                        </MenuItem>
                                    );
                                })}
                        </TextField>
                    </FormControl>
                </Grid>
                <Grid
                    className={IOM.insertActionsBox}
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        width: 410,
                        marginBottom: '20px',
                    }}
                >
                    <SCUIButton
                        className={IOM.btnInsertSubmit}
                        text={t('general.add')}
                        type="primary"
                        sizeType="default"
                        size={'s'}
                        fullwidth
                        onClick={onClick}
                    />
                </Grid>
            </Grid>
        </form>
    );
};

interface IProps {
    setShowSnackbar?: any;
    setSnackbarProperties?: any;
    search?: any;
    onClose?: any;
}
